// const { norm } = require("martha");

// Helper function to update srcset for images
function updateImageSrcset(imageUrl) {
  const srcsetSizes = ["375", "750", "1280", "2048", "3240"];

  // Generate the srcset string
  const srcset = srcsetSizes
    .map((size) => `/cdn/shop/${imageUrl}?width=${size} ${size}w`)
    .join(", ");

  return srcset;
}

async function customOnProductFormChange(event) {
  const productForm = event.target.closest("form");
  const addToCartBtn = productForm.querySelector("[type=submit]");
  const variantInputSelector = productForm.querySelector('[name="id"]:checked');
  const atcTextEl = addToCartBtn.querySelector("span.atc-price-text");
  const atcPriceEl = addToCartBtn.querySelector("span.atc-price");
  const discountTextEl = document.querySelector("span.atc-discount-text");  

  const normalPrice = variantInputSelector.dataset.normalPrice
    ? variantInputSelector.dataset.normalPrice
    : "";

  const subPrice = variantInputSelector.dataset.subPrice
    ? variantInputSelector.dataset.subPrice
    : "";

  const isSubscription = productForm.purchaseOption?.value === "subscription";

  const discountText = variantInputSelector.dataset.discountText
    ? variantInputSelector.dataset.discountText
    : "";

  let new_price = "";
  let new_label = addToCartBtn.dataset?.defaultLabel;

  if (isSubscription) {
    await new Promise((r) => setTimeout(r, 150));
    new_price = productForm
      .querySelector(
        '[name="purchaseOption"][value="subscription"] + .rc-radio__label .rc-radio__price'
      )
      .textContent.trim();

    new_label = addToCartBtn.dataset.subscribeLabel;
  } else if (variantInputSelector?.dataset?.priceMoneyFormat) {
    new_price = variantInputSelector.dataset.priceMoneyFormat;
    new_label = addToCartBtn.dataset.defaultLabel;
  }

  atcTextEl.textContent = new_label;

  // Check if strikethrough pricing is enabled
  const showStrikethrough = window.sectionSettings?.showStrikethroughPricing || false;
  
  if (normalPrice === "" || !showStrikethrough) {
    atcPriceEl.innerHTML = `&nbsp;${new_price}`;
  } else {
    if (isSubscription) {
      atcPriceEl.innerHTML = `&nbsp;<s>${subPrice}</s>&nbsp;${new_price}`;
    } else {
      atcPriceEl.innerHTML = `&nbsp;<s>${normalPrice}</s>&nbsp;${new_price}`;
    }
  }

  if (discountTextEl) {
    discountTextEl.textContent = discountText;
  }
}

function customOnVariantChange() {  
  var variantInputSelector = document.querySelector(
    '[data-product-form] [name="id"]:checked'
  );
  if (!variantInputSelector) return;

  if (variantInputSelector.dataset?.overlay) {
    document.querySelector("#custom-badge").src =
      variantInputSelector.dataset?.overlay;
  } else {
    if (document.querySelector("#custom-badge")) {
      document.querySelector("#custom-badge").src =
        document.querySelector("#custom-badge")?.dataset?.defaultimage;
    }
  }

  document
    .querySelectorAll(".image-slide-variant, .thumb-variant")
    .forEach((img) => {
      img.closest(".thumbnail-button")?.classList.add("hidden");
      img.classList.add("hidden");
    });
  document
    .querySelectorAll(`.image-slide-variant-${variantInputSelector.value}`)
    .forEach((img) => {
      img.closest(".thumbnail-button")?.classList.remove("hidden");
      img.classList.remove("hidden");
    });
  document
    .querySelectorAll(`.thumb-variant-${variantInputSelector.value}`)
    .forEach((thumb, i) => {
      thumb.classList.remove("hidden");
      thumb.closest(".thumbnail-button")?.classList.remove("hidden");
    });
}

class VideoController extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector("video");
    this.overlay = this.querySelector(".video-overlay");

    if (!this.video || !this.overlay) return;

    // Bind event handlers
    this.togglePlay = this.togglePlay.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleEnded = this.handleEnded.bind(this);

    // Attach event listeners
    this.overlay.addEventListener("click", this.togglePlay);
    this.video.addEventListener("pause", this.handlePause);
    this.video.addEventListener("ended", this.handleEnded);

    // if control, add the pausevideo method
    if (this.video.getAttribute("data-control") === "true") {
      this.pauseVideo = this.pauseVideo.bind(this);
      this.video.addEventListener("click", this.stopControlledVideos);
    }
  }

  pauseVideo() {
    console.log(e.target, "targettt");
    if (e.target !== this.overlay) {
      this.video.pause();
      this.overlay.style.display = "flex";
    }
  }

  togglePlay() {
    this.stopControlledVideos();
    if (this.video.paused || this.video.ended) {
      this.video.play();
      this.overlay.style.display = "none";
    }
  }

  handlePause() {
    this.overlay.style.display = "flex";
  }

  handleEnded() {
    this.overlay.style.display = "flex";
    this.video.currentTime = 0;
  }

  stopControlledVideos() {
    document.querySelectorAll("video[data-control='true']").forEach((vid) => {
      if (vid !== this.video) {
        vid.pause();
        const overlay = vid
          .closest("video-controller")
          ?.querySelector(".video-overlay");
        if (overlay) overlay.style.display = "flex";
      }
    });
  }
}

// Define the custom element
if (!customElements.get("video-controller")) {
  customElements.define("video-controller", VideoController);
}

class QuestionHeroController extends HTMLElement {
  constructor() {
    super();
    this.questions = Array.from(this.children);
    this.addEventListener("click", (event) => this.handleClick(event));
  }

  handleClick(event) {
    console.log("wheee");
    const selectedQuestion = event.target.closest(".question");
    if (!selectedQuestion) return;

    this.questions.forEach((question) => {
      if (question !== selectedQuestion) {
        question.removeAttribute("open");
      }
    });

    if (!selectedQuestion.hasAttribute("open")) {
      selectedQuestion.setAttribute("open", "");
    } else {
      selectedQuestion.removeAttribute("open");
    }
  }
}

if (!customElements.get("question-hero-controller")) {
  customElements.define("question-hero-controller", QuestionHeroController);
}

class MultiBeforeAfterController extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.getAttribute("data-id");

    this.beforeAfterHolder = document.querySelector(
      `#multi-before-after-${this.sectionId}`
    );

    if (!this.beforeAfterHolder) return;

    // Bind the event handler for delegation
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    // Attach a single click event listener to the entire component
    this.addEventListener("click", this.handleClick);
  }

  handleClick(event) {
    console.log("click");

    const clickedButton = event.target;

    // Check if the clicked target is a button
    if (clickedButton.tagName === "BUTTON") {
      // Remove the 'open' attribute from all buttons
      const allButtons = this.querySelectorAll("button");
      allButtons.forEach((btn) => btn.removeAttribute("data-open"));

      // Add the 'open' attribute to the clicked button
      clickedButton.setAttribute("data-open", "true");

      // Update the content based on the clicked button's data attributes
      this.updateContent(clickedButton);
    }
  }

  updateContent(button) {
    Array.from(this.beforeAfterHolder.children).forEach((img, index) => {
      if (index === parseInt(button.getAttribute("data-index"))) {
        img.classList.remove("delay-100");
        img.classList.remove("opacity-0");
      } else {
        img.classList.add("delay-100");
        img.classList.add("opacity-0");
      }
    });
  }
}

// Define the custom element
if (!customElements.get("multi-before-after-controller")) {
  customElements.define(
    "multi-before-after-controller",
    MultiBeforeAfterController
  );
}

class MultiDescriptionController extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.getAttribute("data-id"); // Get the sectionId for the component

    this.descriptionElement = this.querySelector(`p`);
    this.imageHolder = document.querySelector(`#image-${this.sectionId}`);
    this.secondHolder = this.querySelector(`#second`);

    // Handle if description or image elements are missing
    if (!this.descriptionElement || !this.imageHolder) return;

    // Bind event handler for delegation
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    // Attach event listener to listen for click events
    this.addEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const clickedButton = event.target;

    // Check if the clicked target is a button
    if (clickedButton.tagName === "BUTTON") {
      // Remove the 'open' attribute from all buttons
      const allButtons = this.querySelectorAll("button");
      allButtons.forEach((btn) => btn.removeAttribute("data-open"));

      // Add the 'open' attribute to the clicked button
      clickedButton.setAttribute("data-open", "true");

      // Update the content based on the clicked button's data attributes
      this.updateContent(clickedButton);
    }
  }

  updateContent(button) {
    // Get the description and image data from the button's attributes
    const description = button.getAttribute("data-desc");
    const imageIndex = button.getAttribute("data-index");

    console.log(imageIndex, "imageIndex");

    // Update the description text
    this.descriptionElement.textContent = description;

    // add opacity-0 to the imageHolder's children, except the one with the index
    this.imageHolder.querySelectorAll("img").forEach((img, index) => {
      console.log(index, "index");
      if (index === parseInt(imageIndex)) {
        img.classList.remove("delay-100");
        img.classList.remove("opacity-0");
      } else {
        img.classList.add("delay-100");
        img.classList.add("opacity-0");
      }
    });

    // add opacity-0 to the secondHolder's children, except the one with the index
    this.secondHolder.querySelectorAll("div").forEach((img, index) => {
      console.log(index, "index");
      if (index === parseInt(imageIndex)) {
        img.classList.remove("delay-100");
        img.classList.remove("opacity-0");
      } else {
        img.classList.add("delay-100");
        img.classList.add("opacity-0");
      }
    });
  }
}

// Define the custom element
if (!customElements.get("multi-description-controller")) {
  customElements.define(
    "multi-description-controller",
    MultiDescriptionController
  );
}

class StatCounter extends HTMLElement {
  constructor() {
    super();
    this._hasAnimated = false;
  }

  connectedCallback() {
    const rawValue = this.getAttribute("data-value") || "0";
    const match = rawValue.match(/^([\d,.]+)(\D*)$/);
    if (!match) return;

    const numericPart = parseFloat(match[1].replace(/,/g, ""));
    const suffix = match[2];
    const startValue = (numericPart / 10) * 7;

    this._numericPart = numericPart;
    this._suffix = suffix;
    this._startValue = startValue;

    // Initialize with half value
    this.innerHTML = Math.floor(startValue).toLocaleString() + suffix;

    this.observeVisibility();
  }

  observeVisibility() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this._hasAnimated) {
            this._hasAnimated = true;
            this.animateValue();
            observer.unobserve(this);
          }
        });
      },
      {
        rootMargin: "0px 0px 20px 0px",
        threshold: 0,
      }
    );

    observer.observe(this);
  }

  animateValue() {
    const duration = 2000;
    const minFrameTime = 1000 / 15;
    const easeOutSine = (t) => Math.sin((t * Math.PI) / 2);

    let startTime = null;
    let lastUpdateTime = 0;

    const update = (currentTime) => {
      if (!startTime) {
        startTime = currentTime;
      }
      const elapsed = currentTime - startTime;

      if (currentTime - lastUpdateTime >= minFrameTime) {
        lastUpdateTime = currentTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeOutSine(progress);
        const currentValue = Math.floor(
          this._startValue + (this._numericPart - this._startValue) * eased
        );
        this.innerHTML = currentValue.toLocaleString() + this._suffix;
      }

      if (elapsed < duration) {
        requestAnimationFrame(update);
      } else {
        // ✅ Snap to final value to avoid off-by-one
        this.innerHTML = this._numericPart.toLocaleString() + this._suffix;
      }
    };

    requestAnimationFrame(update);
  }
}

if (!customElements.get("stat-counter")) {
  customElements.define("stat-counter", StatCounter);
}
